import React, { useState, useEffect } from 'react';
import { dynamicCountdown } from '../../helpers/dynamicCountdown';

export const getCountdownConfig = (countdownValue) => {
  const status = countdownValue && typeof countdownValue === 'object' ? countdownValue.status : countdownValue;
  switch (status) {
    case 'rsvp_closed':
    case 'rsvp_open':
      return {
        text: '3 to 2 days',
        colorClass: 'text-blue-500',
        bgClass: 'bg-blue-100',
        borderClass: 'border-blue-200',

        messageBgClass: 'bg-blue-100',
        messageBorderClass: 'border-blue-200',
        messageColorClass: 'text-gray-700',
        iconColorClass: 'text-blue-500',
      };

    // case 'tomorrow':
    //   return {
    //     text: 'Under 24 hours',
    //     colorClass: 'text-orange-500',
    //     bgClass: 'bg-orange-100',
    //     borderClass: 'border-orange-200',

    //     messageBgClass: 'bg-orange-100',
    //     messageBorderClass: 'border-orange-200',
    //     messageColorClass: 'text-gray-700',
    //     iconColorClass: 'text-orange-500',
    //   };

    // case 'today':
    //   return {
    //     text: 'Under 1 hour',
    //     colorClass: 'text-red-600',
    //     bgClass: 'bg-red-100',
    //     borderClass: 'border-red-200',

    //     messageBgClass: 'bg-red-100',
    //     messageBorderClass: 'border-red-200',
    //     messageColorClass: 'text-gray-700',
    //     iconColorClass: 'text-red-600',
    //   };

    case 'happening_now':
      return {
        text: 'Happening Now',
        colorClass: 'text-green-600',
        bgClass: 'bg-green-100',
        borderClass: 'border-green-200',

        messageBgClass: 'bg-green-100',
        messageBorderClass: 'border-green-200',
        messageColorClass: 'text-gray-700',
        iconColorClass: 'text-green-600',
      };

    default:
      return {
        text: '3 to 2 days',
        colorClass: 'text-blue-500',
        bgClass: 'bg-blue-100',
        borderClass: 'border-blue-200',

        messageBgClass: 'bg-blue-100',
        messageBorderClass: 'border-blue-200',
        messageColorClass: 'text-gray-700',
        iconColorClass: 'text-blue-500',
      };
  }
};

const TimeBlock = ({ value, label, config }) => {
  return (
    <div className="flex flex-col items-center">
      <div className={`flex items-center justify-center w-12 h-12 border rounded-lg font-bold text-3lg ${config.bgClass} ${config.borderClass} ${config.colorClass}`}>
        {String(value).padStart(2, '0')}
      </div>
      <span className="text-[10px] uppercase font-bold text-gray-500 mt-1">{label}</span>
    </div>
  );
};

const Colon = ({ config }) => (
  <div className={`flex items-center justify-center font-bold text-xl px-1 h-12 ${config.colorClass}`}>:</div>
);

export const CountdownLabel = ({ startAt, endAt, rsvpDeadlineDate, labelClassName }) => {
  const [countdownValue, setCountdownValue] = useState(dynamicCountdown(startAt, endAt, rsvpDeadlineDate));
  const { status, days, hours, minutes } = countdownValue || { status: null, days: 0, hours: 0, minutes: 0 };
  useEffect(() => {
    if (status && status === 'happening_now') return;

    const interval = setInterval(() => {
      const newValue = dynamicCountdown(startAt, endAt, rsvpDeadlineDate);

      setCountdownValue((prev) => {
        if (
          prev?.status !== newValue?.status ||
          prev?.days !== newValue?.days ||
          prev?.hours !== newValue?.hours ||
          prev?.minutes !== newValue?.minutes
        ) {
          return newValue;
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [startAt, endAt, status, rsvpDeadlineDate]);

  if (!countdownValue) return null;

  const config = getCountdownConfig(countdownValue);
  if (!config) return null;

  if (countdownValue?.status === 'happening_now') {
    return (
      <div className={`inline-flex items-center h-12 justify-center px-4 py-2 rounded-lg border border-solid ${config.bgClass} ${config.borderClass}`}>
        <span className={`flex items-center gap-2 font-bold text-sm uppercase tracking-wide ${config.colorClass} ${labelClassName || ''}`}>
          <span className={`w-4 h-4 rounded-full bg-green-500`}></span>
          <span className='text-md'>LIVE NOW</span>
        </span>
      </div>
    );
  }

  let prefixLabel = null;
  if (countdownValue?.status === 'rsvp_open') {
    prefixLabel = 'RSVP closing in:';
  } else if (countdownValue?.status === 'rsvp_closed') {
    prefixLabel = 'RSVP closed. Event Starting in:';
  }

  return (
    <div className={`flex flex-col gap-2 items-center justify-center ${labelClassName || ''}`}>
      {prefixLabel && (
        <span className={`font-bold text-sm uppercase tracking-wide text-center ${config.colorClass}`}>
          {prefixLabel}
        </span>
      )}
      <div className="flex items-start justify-center space-x-1">
        <TimeBlock value={days} label="Day" config={config} />
        <Colon config={config} />
        <TimeBlock value={hours} label="Hour" config={config} />
        <Colon config={config} />
        <TimeBlock value={minutes} label="Minute" config={config} />
      </div>
    </div>
  );
}

export default CountdownLabel;
